import * as TooltipRoot from "@radix-ui/react-tooltip";

interface Props {
  content: string | React.ReactNode;
  children: React.ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
}

export const Tooltip = ({ content, children, side = "top", align = "center" }: Props) => {
  return (
    <TooltipRoot.Provider>
      <TooltipRoot.Root delayDuration={100}>
        <TooltipRoot.Trigger asChild>{children}</TooltipRoot.Trigger>
        <TooltipRoot.Portal>
          <TooltipRoot.Content
            side={side}
            align={align}
            sideOffset={4}
            style={{
              visibility: "visible",
              zIndex: 9999,
              maxWidth: "25rem",
              backgroundColor: "black",
              color: "white",
              borderRadius: "0.25rem",
              padding: "0.25rem",
              border: "1px solid #000",
              boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
              wordBreak: "break-all",
              fontSize: "0.75rem",
            }}
          >
            {content}
            <TooltipRoot.Arrow
              width={11}
              height={5}
              style={{
                marginTop: "-1px",
              }}
            />
          </TooltipRoot.Content>
        </TooltipRoot.Portal>
      </TooltipRoot.Root>
    </TooltipRoot.Provider>
  );
};
